import React from 'react'

export const ProfileOptionName: React.FC<{option:string}> = ({option}) => {
  return (
    <p className="text-[14px] leading-[18px] font-bold text-primary cursor-pointer">{option}</p>
  )
}
